import React from "react";

export default function ShortInfoFlex({ children }) {
  return (
    <div className="text-[#21272A] flex justify-start items-center font-normal text-xs lg:text-lg gap-3">
      {children}
    </div>
  );
}
